/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';

import { ClubStatusManager } from '../services/manager';
import { getClubById } from '../services/club';
import { clubActions, clubSlotActions } from './definition';
import { clubSlotParams, getClubSlots } from '../services/field';

function clubIsLoading() {
    return {
        type: clubActions.CLUB_IS_LOADING,
    };
}

const clubReset = () => {
    return {
        type: clubActions.CLUB_RESET,
    };
};

function clubError(e: string) {
    return {
        type: clubActions.CLUB_ERROR,
        error: e,
    };
}

function clubSet(clubs: any) {
    return {
        type: clubActions.CLUB,
        data: clubs,
    };
}

function clubSlotIsLoading() {
    return {
        type: clubSlotActions.CLUB_SLOT_IS_LOADING,
    };
}

const clubSlotReset = () => {
    return {
        type: clubSlotActions.CLUB_SLOT_RESET,
    };
};

function clubSlotError(e: string) {
    return {
        type: clubSlotActions.CLUB_SLOT_ERROR,
        error: e,
    };
}

function clubSlotSet(clubs: any) {
    return {
        type: clubSlotActions.CLUB_SLOT,
        data: clubs,
    };
}

/**
 * Reducer to rest a clubs
 * @param values Data to reset clubs
 */
export const resetStateClub = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(clubReset());
    };
};


/**
 * Reducer to rest a clubs
 * @param values Data to reset clubs
 */
 export const resetStateClubSlot = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(clubSlotReset());
    };
};

/**
 * Reducer to rest a clubs
 * @param values Data to reset clubs
 */
export const resetClubReset = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(clubReset());
    };
};

/**
 * Reducer to reset Clubs
 * @param values Values to reset clubs
 */
export const resetClub = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(clubReset());
    };
};

/**
 * Reducer to get a club by id
 * @param id Id of club to find
 */
export const fetchClubById = (id: string) => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(clubIsLoading());
        try {
            const response = await getClubById(id);
            if (response?.statusCode === ClubStatusManager.CLUB_BY_ID && response.data) {
                dispatch(clubSet(response));
            } else {
                dispatch(clubError('Could not get club'));
            }
        } catch (error: any) {
            dispatch(clubError('No se pudo obtener el club'));
        }
    };
};


/**
 * Reducer to get a club by slot
 * @param query query of club to find
 */
 export const fetchClubBySlot = (query: clubSlotParams) => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(clubSlotIsLoading());
        try {
            const response = await getClubSlots(query);
            if (response?.statusCode === ClubStatusManager.CLUB_SLOTS_AVAILABLE_SUCCESS && response.data) {
                dispatch(clubSlotSet(response));
            } else {
                dispatch(clubSlotError('Could not get club'));
            }
        } catch (error: any) {
            dispatch(clubSlotError('No se pudo obtener el club'));
        }
    };
};